import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52d9cf5e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=52d9cf5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d9cf5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d9cf5e')) {
      api.createRecord('52d9cf5e', component.options)
    } else {
      api.reload('52d9cf5e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=52d9cf5e&scoped=true&", function () {
      api.rerender('52d9cf5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/walletHistory/index.vue"
export default component.exports